import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialNavigationMenu3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 3.81h1.53v24.38h-1.53Zm-1.52 24.38h1.52v1.52h-1.52Zm0-25.91h1.52v1.53h-1.52ZM3.81 29.71h24.38v1.53H3.81Zm21.33-9.14H6.86v1.52H5.33v3.05h1.53v-1.52h18.28v1.52h1.53v-3.05h-1.53zm0-7.62H6.86v1.52H5.33v3.05h1.53V16h18.28v1.52h1.53v-3.05h-1.53zm0-7.62H6.86v1.52H5.33V9.9h1.53V8.38h18.28V9.9h1.53V6.85h-1.53zM6.86 25.14h18.28v1.52H6.86Zm0-7.62h18.28v1.52H6.86Zm0-7.62h18.28v1.53H6.86ZM3.81.76h24.38v1.52H3.81ZM2.29 28.19h1.52v1.52H2.29Zm0-25.91h1.52v1.53H2.29ZM.76 3.81h1.53v24.38H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialNavigationMenu3
